import type {Values} from "@wix/devzai-utils-common";

export const DoppeAutoBlogPostType = {
    Latest: 'Latest',
    Categories: 'Categories',
} as const;

export type DoppeAutoBlogPostType = Values<typeof DoppeAutoBlogPostType>;